module.exports = {
	RIGHT_POSITION: 'RIGHT_POSITION',
	LEFT_POSITION: 'LEFT_POSITION'
}



// WEBPACK FOOTER //
// ./src/utils/PositionConstants.js